import React from "react"

const PictureCaption = ({ data }) => {
  return (
    <div className="picture-caption">
      <div className="pic-container mb-2">
        <img src={data.thumbnail} alt="caption" />
      </div>
      <p>{data.title ? data.title : ""}</p>
    </div>
  )
}

export default PictureCaption
